import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import * as service from '../../services/jobs-service';
import { useAlerts } from '../../hooks/use-alerts';
import { Dialog } from '../../components/Dialog';

export function QueueJob({ queue, type, jobId, onClose }) {
  const [jobDetails, setJobDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const { showError } = useAlerts();

  useEffect(() => {
    service
      .getJob(queue, type, jobId)
      .then(setJobDetails)
      .catch(showError)
      .finally(() => setLoading(false));
  }, [queue, type, jobId, showError]);

  if (!queue || !jobId) return null;

  return (
    <Dialog
      title={`Job Details - ${queue}:${jobId}`}
      onCancel={onClose}
      actions={false}
      width="md"
    >
      <Box sx={{ minHeight: 400 }}>
        {loading ? (
          <Box sx={{ p: 2 }}>Loading...</Box>
        ) : (
          <Box
            component="pre"
            sx={{
              backgroundColor: 'grey.100',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              fontSize: '0.875rem',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
            }}
          >
            {JSON.stringify(jobDetails, null, 2)}
          </Box>
        )}
      </Box>
    </Dialog>
  );
}
